import { render } from "./CheckoutComplete.vue?vue&type=template&id=b5cb925a&scoped=true"
import script from "./CheckoutComplete.vue?vue&type=script&lang=js"
export * from "./CheckoutComplete.vue?vue&type=script&lang=js"

import "./CheckoutComplete.vue?vue&type=style&index=0&id=b5cb925a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5cb925a"]])

export default __exports__